import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Input, Modal, message } from 'antd';
import { useEffect, useState } from 'react';
import css from './modal.module.scss';
export const defaultData = {
    key: 'custome',
    i18n: 'custome',
    desc: '0W/1Hour/day',
    icon: '/img/calculators/mm100/appliance_custom.svg',
    power: 0,
    time: { h: '00', m: '00', t: 0 },
} as any;

export default function ApplianceModal({ config = {}, item = defaultData, onCancel, onConfirm, type = 'edit' }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    const defaultProps = {
        width: 532,
        centered: true,
        closable: false,
        wrapClassName: css.calculatorsmm100step3modal, //'calculators-mm100-step3-modal',
        cancelText: t(`calculators.mm100.step3.cancel`),
        okText: t(`calculators.mm100.step3.confirm`),
        onCancel: onCancel,
        onOk: () => onConfirm(data, type),
    };
    const modalProps = { ...defaultProps, ...config };
    const [data, setData] = useState(type === 'add' ? defaultData : { ...item });
    const MAX_POWER = 10000;
    useEffect(() => {
        setData({ ...item });
    }, [item]);

    const changeValue = (e: any, type: string) => {
        // 校验： 不能为非数字, 不可小于0, 不可为小数
        const value = Number(e.target.value);
        if (String(value) === 'NaN' || value < 0 || value % 1 !== 0) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        // 小时不可大于24
        if (type === 'h' && value > 24) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        // 分钟不可大于等于60
        if (type === 'm' && value >= 60) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        // 24小时时，分钟只能为0
        if (Number(data?.time?.h) === 24 && type === 'm' && value !== 0) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }

        if (type === 'power') {
            if (value > MAX_POWER) {
                return message.error(t(`calculators.mm100.step3.vali_error_max`));
            }
            return setData({
                ...data,
                power: value,
                desc: data?.desc?.replace(String(data?.power), value),
            });
        }
        if (type === 'h') {
            return setData({
                ...data,
                time: { h: value, m: data?.time?.m, t: value + data?.time?.m / 60 },
                desc: `${data?.power}W/${
                    value === 0 ? '' : value + (value === 1 ? t('calculators.mm100.step3.time_h_s') : t('calculators.mm100.step3.time_h'))
                }${Number(data?.time?.m) === 0 ? '' : Number(data?.time?.m) + t('calculators.mm100.step3.time_m')}${t('calculators.mm100.step3.per_day')}`,
            });
        }
        if (type === 'm') {
            return setData({
                ...data,
                time: { h: data?.time?.h, m: value, t: Number(data?.time?.h) + value / 60 },
                desc: `${data?.power}W/${
                    Number(data?.time?.h) === 0
                        ? ''
                        : Number(data?.time?.h) + (data?.time?.h === 1 ? t('calculators.mm100.step3.time_h_s') : t('calculators.mm100.step3.time_h'))
                }${value === 0 ? '' : value + t('calculators.mm100.step3.time_m')}${t('calculators.mm100.step3.per_day')}`,
            });
        }
    };

    return (
        <Modal {...modalProps}>
            <div className="appTitle">
                <div className="titleIcon">
                    <Image
                        src={data?.icon}
                        className="fullImgs"
                        layout="fill"
                        alt={t(`calculators.mm100.step3.${data?.i18n}`)}
                        aria-label={t(`calculators.mm100.step3.${data.i18n}`)}
                    />
                </div>
                <span className="title">{t(`calculators.mm100.step3.${data?.i18n}`)}</span>
            </div>
            <div className="ratePowerBox middleBox">
                <div className="textBox">
                    <span className="text">{t('calculators.mm100.step3.rate_power')}</span>
                    <br />
                    <div className="inputBox">
                        <Input value={data?.power} onChange={(e: any) => changeValue(e, 'power')} />
                        <span className="unit">W</span>
                    </div>
                </div>
                <p className="desc">{t('calculators.mm100.step3.power_desc')}</p>
            </div>
            <div className="timeBox middleBox">
                <div className="textBox">
                    <span className="text">{t('calculators.mm100.step3.time_day')}</span>
                    <br />
                    <div className="inputBox">
                        <Input value={data?.time?.h} onChange={(e: any) => changeValue(e, 'h')} />
                        <span className="unit" style={{ marginRight: '10px' }}>
                            {t('calculators.mm100.step3.time_h')}
                        </span>
                        <Input value={data?.time?.m} onChange={(e: any) => changeValue(e, 'm')} />
                        <span className="unit">{t('calculators.mm100.step3.time_m')}</span>
                    </div>
                </div>
                <p className="desc">{t('calculators.mm100.step3.time_desc')}</p>
            </div>
        </Modal>
    );
}
